import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";

import AdminPage from "@/pages/AdminPage";
import ComingSoon from "@/pages/ComingSoon";
import MarketingLayout from "@/pages/marketing/MarketingLayout";
import HomePage from "@/pages/marketing/HomePage";
import PracticePage from "@/pages/marketing/PracticePage";
import PracticeDetailPage from "@/pages/marketing/PracticeDetailPage";
import ApproachPage from "@/pages/marketing/ApproachPage";
import TeamPage from "@/pages/marketing/TeamPage";
import FirmPage from "@/pages/marketing/FirmPage";
import InsightsPage from "@/pages/marketing/InsightsPage";
import BookPage from "@/pages/marketing/BookPage";
import ContactPage from "@/pages/marketing/ContactPage";

function App() {
  const isPreview =
    typeof window !== "undefined" && window.location.hostname.includes("preview.emergentagent.com");

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/admin" element={<AdminPage />} />

        <Route path="/home" element={<MarketingLayout />}>
          <Route index element={<HomePage />} />
          <Route path="practice" element={<PracticePage />} />
          <Route path="practice/:slug" element={<PracticeDetailPage />} />
          <Route path="approach" element={<ApproachPage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="firm" element={<FirmPage />} />
          <Route path="insights" element={<InsightsPage />} />
          <Route path="book" element={<BookPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>

        <Route path="*" element={<ComingSoon />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
